export function joinSentence(array: any, oxfordComma: boolean): string {
  let lastWord;

  if (array.length > 1) {
    lastWord = ` and ${array.pop()}`;
    if (oxfordComma && array.length > 1) {
      lastWord = `, ${lastWord}`;
    }
  } else {
    lastWord = '';
  }

  return array.join(', ') + lastWord;
}

export default joinSentence;
